import { render } from "./Skills.vue?vue&type=template&id=a9196f8e"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=a9196f8e&lang=scss"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__